const Terms = () => {
    return (
        <div className="flex flex-col margin-x py-10">
            <>
                <h2
                    dir="ltr"
                    style={{
                        lineHeight: "1.44",
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 4pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "17pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#204356",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb - Terms and Conditions
                    </span>
                </h2>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb is an online ordering portal. Foodb is not a restaurant or food preparation entity.&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        The Restaurants available on our Platform operate independently of Foodb. They must follow all
                        federal, state, and local laws, rules, and regulations related to preparing, selling, and
                        marketing food. This includes, but is not limited to, food safety and menu disclosure. Foodb is
                        not responsible for the restaurants' food preparation or safety, and we do not verify that they
                        follow all applicable laws. Additionally, Foodb does not guarantee the quality of the food the
                        restaurants sell or the services they provide, including delivery, whether done by the
                        restaurant itself or a third-party delivery service.
                    </span>
                </p>
                <h2
                    dir="ltr"
                    style={{
                        lineHeight: "1.44",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 4pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "16.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#204356",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Introduction
                    </span>
                </h2>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        1.1. In these Website Terms of Use, unless the context otherwise requires, the following
                        expressions have the following meanings:
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        "Content" will include (but is not limited to) reviews, images, photos, audio, video, location
                        data, nearby places, and all other forms of information or data.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        “Foodb Content” is all of the content that Foodb creates and makes available on the Services,
                        excluding Your Content and Third Party Content. This includes visual interfaces, interactive
                        features, graphics, design, compilation, computer code, products, software, aggregate ratings,
                        reports, other usage-related data related to activities associated with your account, and all
                        other elements and components of the Services.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        "Third Party Content '' means content that comes from parties other than Foodb or its users and
                        is available on the Services.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        "We/Us/Our" means Foodb.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        “Takeaway/ Restaurant” refers to the available food outlets in Foodb you wish to place your
                        order with.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        “Website” means order.foodb.co.uk
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        “App” means Foodb mobile application that you can download to place food orders.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        1.2. Product Orders: We provide a platform for you to communicate your orders for food and
                        beverages ("Products") from restaurants ("Restaurants") that are listed on our website. The
                        legal contract for the sale and purchase of Products is between you and the Restaurant that you
                        place your order with. We act as an agent for the Restaurants and conclude the sale on their
                        behalf.
                    </span>
                </p>
                <h2
                    dir="ltr"
                    style={{
                        lineHeight: "1.44",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 4pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "16.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#204356",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Access to our website
                    </span>
                </h2>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        2.1. Access to Site:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Access to our Site is free of charge. You may access some areas of the Website without making an
                        Order or registering your details with us.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        2.2. Responsibility: You confirm that you have read and understood these terms. You are
                        responsible for making all necessary arrangements to access the Website. You are also
                        responsible for ensuring that all people who access the Website through your internet connection
                        are aware of these terms and comply with them.
                    </span>
                </p>
                <h2
                    dir="ltr"
                    style={{
                        lineHeight: "1.44",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 4pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "16.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#204356",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Allergy
                    </span>
                </h2>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        3.1. Allergy:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        In case of you having an allergy in any specific food item please contact the restaurant and
                        check directly with them before placing the order.
                    </span>
                </p>
                <h2
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "3pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "16pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#000000",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Process of the order
                    </span>
                </h2>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        4.1. Process of Order:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        You can order from the menu of your chosen Restaurant; you will proceed to the next step to
                        place your order by selecting the "checkout" button. &nbsp;Please carefully review all of the
                        information you have provided to ensure that it is accurate and if it is not; please correct it
                        before selecting the checkout button once you complete the process of ordering then you are into
                        a contract with the restaurant.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        4.2. Canceling the Order:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you have placed an order using a credit or debit card and wish to cancel it, you should
                        contact the restaurant directly to request cancellation or a refund.&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        4.3. Delivery/Collection:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        The estimated delivery and collection times are provided by the restaurant, and we do not
                        guarantee that your order will be delivered or available for collection within the given time.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        4.4. Payment methods:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Payment for Orders must be made by an accepted credit or debit card through the Website. You can
                        also pay through Google Pay or Apple Pay.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Your use of Google Pay or Apple Pay is subject to the terms and conditions, including the
                        privacy policies, of Google and Apple, respectively. By using Google Pay, you hereby accept the
                        Google Pay API Terms of Service found here:&nbsp;
                    </span>
                    <a href="https://payments.developers.google.com/terms/sellertos" style={{ textDecoration: "none" }}>
                        <span
                            style={{
                                fontSize: "10.5pt",
                                fontFamily: "Nunito,sans-serif",
                                color: "#1155cc",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            https://payments.developers.google.com/terms/sellertos
                        </span>
                    </a>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        . By using Apple Pay, you hereby accept the terms and conditions found here:&nbsp;
                    </span>
                    <a
                        href="https://www.apple.com/legal/applepayments/direct-payments/"
                        style={{ textDecoration: "none" }}
                    >
                        <span
                            style={{
                                fontSize: "10.5pt",
                                fontFamily: "Nunito,sans-serif",
                                color: "#1155cc",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            https://www.apple.com/legal/applepayments/direct-payments/
                        </span>
                    </a>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        4.5. Saved Card:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        To save your credit or debit card for future online payments, you must provide us with your card
                        details and consent to us storing them on your account.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Payment for orders on Foodb through online payment can be made by a credit or debit card saved
                        on your profile through our Service (Payment Method).
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        You may edit/change/remove your card details at any point of time by providing the required
                        information for authentication.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        By agreeing to these terms, you consent to the storage of your card details, including your
                        cardholder name, card number, and expiration date, for the purpose of facilitating future
                        payments.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        4.6. Compensation:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you are dissatisfied with the quality of any Products or the service provided by a Restaurant
                        and wish to seek a refund, a proportionate price reduction, or any other compensation, you
                        should contact the Restaurant directly to lodge your complaint and follow the Restaurant's own
                        complaint procedures, if applicable.The legal contract for the supply and purchase of Products
                        is between you and the Restaurant that you place your Order with. We have no control over
                        Restaurants and the quality of the Products or service that they provide. We are not able to
                        provide, and have no responsibility or liability for providing, any compensation to you on
                        behalf of any Restaurant.
                    </span>
                </p>
                <h2
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "3pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "16pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#000000",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        DISCLAIMERS
                    </span>
                </h2>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Website information:
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;While we try to ensure that the information on the Website is correct and complete, we
                        cannot guarantee its accuracy or completeness. We may make changes to the material on the
                        Website, or to the functionality, Products, and prices described on it, at any time without
                        notice. The material on the Website may be out of date, and we make no commitment to update that
                        material.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <br />
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Menu information:
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;Restaurants are responsible for providing us with up-to-date menu information when they
                        sign up with us. We then include this information on their dedicated page on the Website. We
                        will do our best to republish this information on the website or app exactly as it appears on
                        the restaurant's menu. However, we cannot guarantee the accuracy or completeness of this
                        information. If you, or someone you are ordering for, has a concern about food allergies,
                        intolerances, or other dietary preferences, you should always contact the Restaurant directly
                        before placing your order.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <br />
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Restaurant actions and omissions:
                    </span>
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;The legal contract for the supply and purchase of Products is between you and the
                        Restaurant that you place your Order with. We have no control over the actions or omissions of
                        any Restaurants. You acknowledge and agree to the following by using the Website:
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <br />
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We do not give any undertaking that the Products ordered from any Restaurant through the Website
                        will be of satisfactory quality or suitable for your purpose. We disclaim any warranties,
                        express or implied, including warranties of merchantability and fitness for a particular
                        purpose.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <br />
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Estimated times for deliveries and collections are provided by the Restaurants and are only
                        estimates. Neither we nor the Restaurants guarantee that Orders will be delivered or will be
                        available for collection within the estimated times.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 15pt 0pt",
                    }}
                >
                    <br />
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.38",
                        textAlign: "justify",

                        marginTop: "0pt",
                        marginBottom: "15pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10.5pt",
                            fontFamily: "Nunito,sans-serif",
                            color: "#444444",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We encourage all of our Restaurants to accept all Orders and to communicate any rejection
                        promptly. We will notify you as soon as reasonably practicable if a Restaurant rejects your
                        Order. However, we do not guarantee that Restaurants will accept and fulfill all Orders.
                        Restaurants have the absolute discretion to reject Orders at any time for any reason, including,
                        but not limited to, being busy, due to weather conditions, or for any other reason. Restaurants
                        are not obligated to deliver an Order to an address outside of their set delivery radius, which
                        may change from time to time.
                    </span>
                </p>
            </>
        </div>
    );
};
export default Terms;
